import { createRouter, createWebHistory } from 'vue-router'
import { navigationGuard, LoginCallback } from '@okta/okta-vue'
import WelcomePage from '../views/WelcomePage.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/login/callback",
      component: LoginCallback,
    },
    {
      path: "/",
      name: "home",
      meta: {
        requiresAuth: true,
      },
      component: WelcomePage,
    },
    {
      path: "/opening/:opening_id",
      name: "application",
      meta: {
        requiresAuth: true,
      },
      props: true,
      component: () => import("../views/ApplicationProcess.vue"),
    },
    {
      path: "/survey/case/:case_id",
      name: "case-survey",
      props: true,
      meta: {
        requiresAuth: true,
      },
      component: () => import("../views/CaseSurveyPage.vue"),
    },
    {
      path: "/question/:question_id/:lms_user_id/:lms_course_id/:lms_module_id",
      name: "question",
      props: true,
      meta: {
        requiresAuth: true,
      },
      component: () => import("../views/QuestionPage.vue"),
    },
    {
      path: "/voice-assessment",
      name: "voice-assessment",
      meta: {
        requiresAuth: true,
      },
      props: true,
      component: () => import("../views/VoiceAssessment.vue"),
    },
    {
      path: "/requests",
      name: "requests",
      meta: {
        requiresAuth: true,
      },
      component: () => import("../views/CurrentRequests.vue"),
    },
    {
      path: "/requests/document-verification",
      name: "doc-request",
      meta: {
        requiresAuth: true,
      },
      component: () => import("../views/SocureDocumentRequest.vue"),
    },
    {
      path: "/requests/login-verification",
      name: "login-request",
      meta: {
        requiresAuth: true,
      },
      component: () => import("../views/LoginVerificationRequest.vue"),
    },
    {
      path: "/requests/payment",
      name: "payment",
      component: () => import("../views/PaymentProcess.vue"),
    },
  ],
});
router.beforeEach(navigationGuard)

export default router
